// Límites de la fecha de nacimiento, compartidos por los ABM que cargan personas:
// agentes y usuarios internos.
//
// Cada límite vive en DOS lugares por formulario y tienen que decir lo mismo:
//
//   1. `min` / `max` del input — el calendario nativo no deja elegir fuera del rango.
//      Es la defensa real: el usuario no llega a equivocarse.
//   2. El `.test()` de yup — avisa al enviar. Cubre lo que no pasa por el calendario:
//      un valor tipeado a mano, un pegado, un autocompletado del navegador.
//
// Por eso los números viven acá y no repetidos en cada modal.

export const EDAD_MINIMA = 10;
export const EDAD_MAXIMA = 100;

/**
 * Fecha a "YYYY-MM-DD", que es el formato del `<input type="date">`.
 *
 * Se arma con las partes LOCALES y no con `toISOString()`, que convierte a UTC: al
 * oeste de Greenwich eso corre la fecha un día para atrás, y en los bordes del rango
 * —justo donde importa— el límite quedaba corrido.
 */
const aISO = (fecha) =>
    [
        fecha.getFullYear(),
        String(fecha.getMonth() + 1).padStart(2, "0"),
        String(fecha.getDate()).padStart(2, "0"),
    ].join("-");

/**
 * Hoy menos N años.
 *
 * `setFullYear` sobre un 29 de febrero cae en el 1 de marzo del año no bisiesto. Es un
 * día de corrimiento en el borde del rango y no vale la pena corregirlo: nadie carga
 * una fecha de nacimiento que dependa de eso.
 */
const hoyMenosAnios = (anios) => {
    const fecha = new Date();
    fecha.setFullYear(fecha.getFullYear() - anios);
    return aISO(fecha);
};

/** La fecha más RECIENTE admitida. Al ser hoy menos 10 años, ya excluye el futuro. */
export const fechaNacimientoMaxima = () => hoyMenosAnios(EDAD_MINIMA);

/** La más ANTIGUA admitida. */
export const fechaNacimientoMinima = () => hoyMenosAnios(EDAD_MAXIMA);

export const MENSAJE_FECHA_NACIMIENTO = `La persona tiene que tener entre ${EDAD_MINIMA} y ${EDAD_MAXIMA} años`;

/**
 * Para el `.test()` de yup.
 *
 * Compara las cadenas directamente, sin parsear a Date: "YYYY-MM-DD" ordena igual
 * alfabéticamente que cronológicamente, así que `<=` y `>=` alcanzan y no hay zona
 * horaria que pueda meterse en el medio.
 *
 * El campo vacío pasa: que sea obligatorio o no lo decide el `.required()` de cada
 * formulario, no esta función.
 */
export const fechaNacimientoValida = (valor) =>
    !valor ||
    (valor >= fechaNacimientoMinima() && valor <= fechaNacimientoMaxima());
